import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { DataProvider } from '../../providers/data';
import { LoadingProvider } from '../../providers/loading';
import { AlertProvider } from '../../providers/alert';

import { Settings } from '../../settings';
@Component({
  selector: 'page-add-members',
  templateUrl: 'add-members.html'
})
export class AddMembersPage {
  private groupId: any;
  private group: any;
  private groupMembers: any;
  private friends: any;
  private searchFriend: any;
  private toAdd: any;
  private user: any;
  // AddMemberPage
  // This is the page where the user can add their friends to an existing group.
  // The user can only add their friends to the group.
  constructor(public navCtrl: NavController, public navParams: NavParams, public dataProvider: DataProvider,
    public loadingProvider: LoadingProvider, public alertCtrl: AlertController,
    public alertProvider: AlertProvider) { }

  ionViewDidLoad() {
    // Initialize
    this.groupId = this.navParams.get('groupId');

    this.searchFriend = '';
    this.toAdd = [];
    this.loadingProvider.show();

    // Get user information for system message sent to the group when a member was added.
    this.dataProvider.getCurrentUser().snapshotChanges().subscribe((user) => {
      this.user = user.payload.val();
    });

    // Get group information
    this.dataProvider.getGroup(this.groupId).snapshotChanges().subscribe((group) => {
      this.group = group.payload.val();
      this.groupMembers = null;
      // Get group members
      if (group.payload.val().members) {
        group.payload.val().members.forEach((memberId) => {
          this.dataProvider.getUser(memberId).snapshotChanges().subscribe((member) => {
            let m = { $key: member.key, ...member.payload.val()};
            this.addOrUpdateMember(m);
          });
        });

        // Get user's friends to add
        this.dataProvider.getCurrentUser().snapshotChanges().subscribe((account) => {

          if(Settings.chatType == 'with-friends') {
              if (account.payload.val().friends) {
                  for (var i = 0; i < account.payload.val().friends.length; i++) {
                      this.dataProvider.getUser(account.payload.val().friends[i]).snapshotChanges().subscribe((friendRes) => {
                          // Only friends that are not yet a member of this group can be added.
                          let friend = { $key: friendRes.key, ...friendRes.payload.val()};
                          console.log(friend)
                          if (!this.isMember(friend))
                              this.addOrUpdateFriend(friend);
                      });
                  }
                  if (!this.friends) {
                      this.friends = [];
                  }
              } else {
                  this.friends = [];
              }
          } else {

              this.dataProvider.getUsers().snapshotChanges().subscribe((accounts) => {

                  let acc = accounts.filter( c => {
                      let m = {$key: c.key}
                      if(c.key == null && c.key == undefined && c.payload.val() == null) return false;
                      if(c.payload.val().name == '' || c.payload.val().name == ' ' || c.payload.val().name == undefined) return false;
                      if(c.payload.val().publicVisibility == false) return false;
                      if(this.isMember(m)) return false;
                      return true;
                  });

                  this.friends = acc.map(c=>{
                      return { $key: c.key, ...c.payload.val() }
                  })


              });

              if (!this.friends) {
                  this.friends = [];
              }

          }

        });
      }

      this.loadingProvider.hide();
    });
  }

  // Check if friend is a member of the group or not.
  isMember(friend) {
    if (this.groupMembers) {
      for (var i = 0; i < this.groupMembers.length; i++) {
        if (this.groupMembers[i].$key == friend.$key) {
          return true;
        }
      }
    }
    return false;
  }

  // Check if friend is already on the list of members to be added.
  isAdded(friend) {
    if (this.toAdd) {
      for (var i = 0; i < this.toAdd.length; i++) {
        if (this.toAdd[i].$key == friend.$key) {
          return true;
        }
      }
    }
    return false;
  }

  // Toggle for adding/removing friend on the list of members to be added.
  addOrRemove(friend) {
    if (this.isAdded(friend)) {
      this.remove(friend);
    } else {
      this.add(friend);
    }
  }

  // Add or update friend information for real-time sync.
  addOrUpdateFriend(friend) {
    if (!this.friends) {
      this.friends = [friend];
    } else {
      var index = -1;
      for (var i = 0; i < this.friends.length; i++) {
        if (this.friends[i].$key == friend.$key) {
          index = i;
        }
      }
      if (index > -1) {
        this.friends[index] = friend;
      } else {
        this.friends.push(friend);
      }
    }
  }

  // Add or update member information for real-time sync.
  addOrUpdateMember(member) {
      console.log(member);
      if (this.group) {
          if (this.group.members.indexOf(member.$key) > -1) {
              // User exists in the group.
              if (!this.groupMembers) {
                  this.groupMembers = [member];
              } else {
                  var index = -1;
                  for (var i = 0; i < this.groupMembers.length; i++) {
                      if (this.groupMembers[i].$key == member.$key) {
                          index = i;
                      }
                  }
                  // Add/Update User.
                  if (index > -1) {
                      this.groupMembers[index] = member;
                  } else {
                      this.groupMembers.push(member);
                  }
              }
          } else {
              // User already left the group, remove member from list.
              var index1 = -1;
              for (var j = 0; j < this.groupMembers.length; j++) {
                  if (this.groupMembers[j].$key == member.$key) {
                      index1 = j;
                  }
              }
              if (index1 > -1) {
                  this.groupMembers.splice(index1, 1);
              }
          }
      }
  }

  // Add friend to the list of to be added.
  add(friend) {
    this.toAdd.push(friend);
  }

  // Remove friend from the list of to be added.
  remove(friend) {
    this.toAdd.splice(this.toAdd.indexOf(friend), 1);
  }

  // Back
  back() {
    this.navCtrl.pop();
  }

  // Get names of the members to be added to the group.
  getNames() {
    var names = '';
    this.toAdd.forEach((friend) => {
      names += friend.name + ', ';
    });
    return names.substring(0, names.length - 2);
  }

  // Confirm adding of new members, afterwards add the members.
  done() {
    this.alertCtrl.create({
      title: 'Add Members',
      message: '<b>' + this.getNames() + '</b> zur Gruppe hinzufügen?',
      buttons: [
        {
          text: 'Nein'
        },
        {
          text: 'Ja',
          handler: data => {
            // Proceed
            this.loadingProvider.show();
            this.toAdd.forEach((friend) => {
              // Add groupInfo to each friend added to the group.

              // Add friend as members of the group.
              console.log(friend.$key);
              console.log(this.group.members);
              this.group.members.push(friend.$key);
              // Add system message that the members are added to the group.
            });

            this.group.messages.push({
              date: new Date().toString(),
              sender: this.user.userId,
              type: 'system',
              message: this.user.name + ' hat ' + this.getNames() + ' hinzugefügt.',
              icon: 'md-contacts'
            });

            // Update group data on the database.
            this.dataProvider.getGroup(this.groupId).update({
              members: this.group.members,
              messages: this.group.messages
            }).then(() => {
              // Back.
              this.loadingProvider.hide();
              this.navCtrl.pop();
            });
          }
        }
      ]
    }).present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/add-members/add-members.ts